import i18next, { i18n } from 'i18next';
import LocizeBackend from 'i18next-locize-backend';
import LocizeLastUsed from 'locize-lastused';
import { initReactI18next } from 'react-i18next';

import { ITenantConfig } from '../services/common/ConfigService';

export default class I18nFactory {
	static async create(config: ITenantConfig): Promise<i18n> {
		i18next.use(initReactI18next);
		i18next.use(LocizeBackend);
		i18next.use(LocizeLastUsed);

		const savedLanguage = localStorage.getItem('language');
		await i18next.init({
			lng: savedLanguage == null ? 'en' : savedLanguage,
			fallbackLng: 'en',
			ns: 'translation',
			defaultNS: 'translation',
			debug: false,
			interpolation: {
				escapeValue: false, // already escaped by react
			},
			backend: {
				referenceLng: 'en',
				projectId: config.LOCIZE_PROJECT_ID,
				apiKey: config.LOCIZE_API_KEY,
			},
			locizeLastUsed: {
				projectId: config.LOCIZE_PROJECT_ID,
				apiKey: config.LOCIZE_API_KEY,
				referenceLng: 'en',
				allowedHosts: ['localhost', 'staging.ontreams.com'],
			},
		});
		return i18next;
	}
}
